import base from './base'

export const dreamShaperApi = base.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    addDreamshaper: builder.mutation<
      void,
      { url: string; classroom_subject_id: string | undefined }
    >({
      query: (body) => ({
        url: 'teachers/dreamshapers',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Classroom'],
    }),
    updateDreamshaper: builder.mutation<
      void,
      { body: { url: string }; id: number | null | undefined }
    >({
      query: ({ body, id }) => ({
        url: `teachers/dreamshapers/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Classroom'],
    }),
  }),
})

export const { useAddDreamshaperMutation, useUpdateDreamshaperMutation } = dreamShaperApi
